<template>
  <section class="t-courses" v-if="data">
    <div class="t-courses__header">
      <h2>{{ title }}</h2>  
      <div class="t-courses__wrapperBtns">
        <router-link v-if="link && !mobileState" :to="{name: link.url}" class="t-btn t-btn_white"><span>{{ link.title }}</span></router-link>
        <div class="t-courses__arrows" :class="{_hidden: data.length <= 3}" v-if="!mobileState">
          <div :class="'t-courses__prev t-courses__prev_' + type">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 4H13M1 4L5 1M1 4L5 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div :class="'t-courses__next t-courses__next_' + type">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 4H1M13 4L9 1M13 4L9 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>

    </div> 
    <swiper :options="mobileState ? swiperOption_courses_mobile : swiperOption_courses" ref="courses">
      <swiper-slide v-for="(item, index) in data" :key="index">
        <cmp-course :data="item" class="t-courseItem_single"></cmp-course>
      </swiper-slide>
    </swiper>
    <div v-if="mobileState" class="t-courses__pagination" :class="['t-courses__pagination_' + type,  {'_flex-start':(data.length > 5)}]"></div>

    <router-link v-if="link && mobileState" :to="{name: link.url}" class="t-btn t-btn_white"><span>{{ link.title }}</span></router-link>
  </section>
</template>

<script>
    import {mapGetters} from 'vuex'

    import Course from './Course.vue'
    export default {
        data(){
            return{
                swiperOption_courses: {
                    autoHeight: true,
                    slidesPerView: 3,
                    spaceBetween: 24,
                    threshold: 10,
                    navigation: {
                        nextEl: '.t-courses__next_' + this.type,
                        prevEl: '.t-courses__prev_' + this.type
                    }
                },
                swiperOption_courses_mobile: {
                    autoHeight: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                    threshold: 10,
                    pagination: {
                        el: '.t-courses__pagination_' + this.type,
                        dynamicBullets: true
                    }
                }
            }
        },
        components: {
            'cmp-course': Course
        },
        computed: {
            ...mapGetters(['mobileState'])
        },
        props: ['data', 'type', 'title', 'link', 'courseClass']
    }
</script>

<style lang="sass">
.t-courses
  width: 960px
  max-width: 100%
  margin: 0 auto
  position: relative
  .t-courseItem
    display: block
    margin: 0
    .t-courseItem__statusBar
      display: none
  &__header
    color: $blue
    margin: 0 0 24px
    padding: 12px 24px
    background: #ffffff
    border-radius: 16px
    display: flex
    flex-direction: row
    flex-wrap: wrap
    justify-content: space-between
    align-items: center
    h2
      margin: 8px 20px 8px 0px
      flex-grow: 1
    .t-btn
      margin: -5px 0
      white-space: nowrap
  &__wrapperBtns
    display: flex
    flex-direction: row
    flex-wrap: wrap
    justify-content: flex-end
    align-items: center
  .swiper-container
    margin: 0 -12px -32px
    padding: 0 12px 32px
    .t-courseItem
      max-width: 100%
  &__prev, &__next
    width: 40px
    height: 40px
    display: flex
    align-items: center
    justify-content: center
    cursor: pointer
    outline: none
    border-radius: 100%
    &.swiper-button-disabled
      path
        stroke: #B8D7F5
  &__prev
    margin-right: 16px
  &__arrows
    display: flex
    align-items: center
    justify-content: center
    margin:  -4px 0 -4px 32px
    &._hidden
      display: none
  &__pagination
    display: flex
    align-items: center
    justify-content: center
    margin: 0 auto
    .swiper-pagination-bullet
      margin: 0 2px
      background: $disabled
      opacity: 1
    .swiper-pagination-bullet-active
      background: $turquoise

@media (max-width: 769px)
  .t-courses
    &__header
      margin: 0 0 16px
    h2
      padding: 0 16px
      background: transparent
    .swiper-container
      width: 100%
      margin: 0
      padding: 0 0 32px
    &__pagination
      + .t-btn
        margin: 24px 24px 0
        display: block
</style>


// WEBPACK FOOTER //
// src/vue_components/CoursesSlider.vue